import { render, staticRenderFns } from "./layout-wrapper.vue?vue&type=template&id=5585819e&scoped=true"
import script from "./layout-wrapper.vue?vue&type=script&lang=js"
export * from "./layout-wrapper.vue?vue&type=script&lang=js"
import style0 from "./layout-wrapper.vue?vue&type=style&index=0&id=5585819e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template_ptp2uvm53q35aphlzqn6rhtzgm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585819e",
  null
  
)

export default component.exports